var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.rim)?_c('div',[_c('h3',[_vm._v(" "+_vm._s(_vm.rim.manufacturer.name)+" - "+_vm._s(_vm.rim.model))]),_vm._v(" "),_c('ul',[(_vm.rim.diameter > 0)?_c('li',[_vm._v("Diameter: "+_vm._s(_vm.rim.diameter)+" mm")]):_vm._e(),_vm._v(" "),(_vm.rim.weight > 0)?_c('li',[_vm._v("Weight: "+_vm._s(_vm.rim.weight)+" g")]):_vm._e()])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30f378c9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/rim-display.vue
// module id = 126
// module chunks = 0